module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7ab00ab8daefd87e10f305514cb6a253.png";